// extracted by mini-css-extract-plugin
export default {"componentWrapper":"SearchInput_componentWrapper__jy72e","form":"SearchInput_form__5Bc+Z","searchButton":"SearchInput_searchButton__3wb0r","input":"SearchInput_input__3j3Oq"};